<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.co
 * @Date: 2021-03-15 18:03:58
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-09-13 17:41:28
 * @FilePath: /dsicm-admin-web/src/components/global/BaseUploadFile/BaseUploadFile.vue
-->
<template>
  <div class="ele-upload-image">
    <!-- 图片列表 -->
    <ele-gallery v-if="!customUploadBtn" :lazy="lazy" :remove-fn="handleRemove" :size="size"
      :height="height ? height : size" :sliceSingle="true" :source="value" :thumbSuffix="thumbSuffix" :title="title" />
    <!-- 上传组件 -->
    <el-upload v-loading="compressLoad" element-loading-text="压缩中..." class="upload-image" :accept="accept" :action="action" :before-upload="handleBeforeUpload" :data="data"
      :disabled="disabled || uploading" :drag="Boolean(drag)" :headers="headers" :http-request="httpRequest"
      :list-type="customUploadBtn ? 'text' : (drag ? 'picture' : 'picture-card')" :multiple="multiple" :name="name"
      :on-change="handleChange" :on-error="handleUploadError" :on-success="handleUploadSuccess" :show-file-list="false"
      :style="{
        marginBottom: ((multiple || checkMore) && computedValues.length) ? '20px' : '0px',
        'width': size + 'px',
        'line-height': (height ? height : size) + 'px',
        'height': (height ? height : size) + 'px'

      }" :withCredentials="withCredentials" ref="upload" v-if="!crop" v-show="isShowUpload">
      <div v-loading="uploading">
        <!-- drag显示 -->
        <template v-if="drag">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
        </template>

        <!-- 非drag -->
        <template v-else>
          <el-button v-if="customUploadBtn" type="primary" size="medium">{{ customUploadBtn }}</el-button>
          <div v-else :style="{
            width: size + 'px',
            height: (height ? height : size) + 'px',
            lineHeight: (height ? height : size) + 'px',
          }">
            <i class="el-icon-plus"></i>
          </div>
        </template>
      </div>

      <!-- 公共 -->
      <div class="el-upload__tip" slot="tip" v-if="showTip">
        请上传
        <b style="color: #F56C6C">{{ fileType.length ? fileType.join('/') : '图片' }}</b>
        格式文件
        <template v-if="fileSize">
          ，且大小不超过
          <b style="color: #F56C6C">{{ fileSize }}MB</b>
        </template>
      </div>

    </el-upload>

    <div v-if="crop">
      <div :style="{
        width: size + 'px',
        height: (height ? height : size) + 'px',
        lineHeight: (height ? height : size) + 'px',
      }" @click="showCrop" class="el-upload el-upload--picture-card" v-show="isShowUpload">
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </div>

      <cropper :field="name" :headers="headers" :height="cropHeight" :noCircle="cropHeight !== cropWidth" :params="data"
        :url="action" :width="cropWidth" :withCredentials="withCredentials" @crop-success="handleCropSuccess"
        @crop-upload-fail="handleCropUploadError" @crop-upload-success="handleCropUploadSuccess"
        @src-file-set="handleSetFileSet" class="ele-upload-image--cropper" img-format="png" ref="cropper"
        v-if="isShowCrop" v-model="isShowCrop">
      </cropper>
    </div>

    <div class="message" v-if="message" :style="{
      marginBottom: ((multiple || checkMore) && computedValues.length) ? '20px' : '0px'
    }">
      <span>{{ message }}</span>

    </div>
  </div>
</template>

<script>
import Cropper from "vue-image-crop-upload";
import EleGallery from "vue-ele-gallery";
import * as imageConversion from "image-conversion";
var size, height;
export default {
  name: "EleUploadImage",
  props: {
    customUploadBtn: {
      type: String,
      default: ""
    },
    // 值

    value: {
      type: [String, Array],
      default() {
        return [];
      }
    },
    // 动态索引
    itemIndex: {
      type: Number
    },
    // 是否压缩图片
    isCompress: {
      type: Boolean,
      default: false
    },
    // 是否剪裁
    crop: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 图片显示大小
    size: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 0
    },
    // 裁剪高度
    cropHeight: {
      type: Number
    },
    // 裁剪宽度
    cropWidth: {
      type: Number
    },
    // 大小限制(MB)
    fileSize: {
      type: Number
    },
    // 响应处理函数
    responseFn: Function,
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => []
    },
    // 是否显示上传成功的提示
    isShowSuccessTip: {
      type: Boolean,
      default: true
    },
    // 缩略图后缀, 例如七牛云缩略图样式 (?imageView2/1/w/20/h/20)
    thumbSuffix: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    // 弹窗标题
    title: String,
    // 图片懒加载
    lazy: {
      type: Boolean,
      default: false
    },
    // 上传地址 (同官网)
    action: {
      type: String,
      required: true
    },
    // 设置上传的请求头部
    headers: {
      type: Object,
      default() {
        return {
          Authorization: localStorage.getItem("Authorization")
        };
      }
    },
    // 文件个数显示(同官网)
    limit: Number,
    // 是否启用拖拽上传 (同官网)
    drag: {
      type: Boolean,
      default: false
    },
    // 	支持发送 cookie 凭证信息 (同官网)
    withCredentials: {
      type: Boolean,
      default: false
    },
    // 是否支持多选文件 (同官网)
    multiple: {
      type: Boolean,
      default: false
    },
    checkMore: {
      type: Boolean,
      default: false
    },
    // 上传时附带的额外参数(同官网)
    data: Object,
    // 上传的文件字段名 (同官网)
    name: {
      type: String,
      default: "file"
    },
    // 覆盖默认的上传行为，可以自定义上传的实现 (同官网)
    httpRequest: Function,
    // 接受上传的文件类型（thumbnail-mode 模式下此参数无效）(同官网)
    accept: String,
    // 删除前的操作
    beforeRemove: Function,
    beforeUpLFn: null,
    widthHeightVali: false, //是否限制宽高
    widthValue: null, //限制的宽的像素
    heightValue: null, //限制的高的像素
    sizeOfThe: null, //判断是否不大于lessEqual，不小于greaterEqual，等于
    doRemoveNo: {
      type: Boolean,
      default: true
    } //是否用这个删除
  },

  components: {
    Cropper,
    EleGallery
  },
  data() {
    return {
      compressLoad:false,
      cropData: {},
      isShowCrop: false,
      uploading: false,
      fileList: [],
      showUploadLenght: "" //超过6张隐藏上传功能
    };
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType.length || this.fileSize);
    },
    computedValues() {
      if (this.value) {
        if (typeof this.value === "string") {
          return [this.value];
        } else {
          this.showUploadLenght = this.value.length;
          return [...this.value];
          // return  (this.showUploadLenght = this.value.length,[...this.value])
        }
      } else {
        return [];
      }
    },
    beforeUpBool() {
      if (typeof this.beforeUpLFn == "function") {
      }
    },
    isShowUpload() {
      if (this.multiple || this.checkMore) {
        return true;
      } else {
        return this.computedValues.length === 0;
      }
    },
    successFiles() {
      return this.fileList.filter(file => file.status === "success");
    }
  },
  watch: {
    size(value) {
      size = value;
      height = this.height ? this.height : size;
    },
    beforeUpLFn(value, old) { },
    isShowCrop(value) {
      if (value === false) {
        this.cropData = {};
      }
    },
    disabled(value, ov) { }
  },
  methods: {
    // /* 图片压缩方法-canvas压缩 */
    // compressUpload(image, file) {
    //   let canvas = document.createElement("canvas");
    //   let ctx = canvas.getContext("2d");
    //   let initSize = image.src.length;
    //   let { width } = image,
    //     { height } = image;
    //   canvas.width = width;
    //   canvas.height = height;
    //   ctx.fillRect(0, 0, canvas.width, canvas.height);
    //   ctx.drawImage(image, 0, 0, width, height);

    //   // 进行最小压缩0.1
    //   let compressData = canvas.toDataURL(file.type || "image/jpeg", 0.5);

    //   // 压缩后调用方法进行base64转Blob，方法写在下边
    //   let blobImg = this.dataURItoBlob(compressData);
    //   return blobImg;
    // },

    // /* base64转Blob对象 */
    // dataURItoBlob(data) {
    //   let byteString;
    //   if (data.split(",")[0].indexOf("base64") >= 0) {
    //     byteString = atob(data.split(",")[1]);
    //   } else {
    //     byteString = unescape(data.split(",")[1]);
    //   }
    //   let mimeString = data
    //     .split(",")[0]
    //     .split(":")[1]
    //     .split(";")[0];
    //   let ia = new Uint8Array(byteString.length);
    //   for (let i = 0; i < byteString.length; i += 1) {
    //     ia[i] = byteString.charCodeAt(i);
    //   }
    //   return new Blob([ia], { type: mimeString });
    // },

    showCrop() {
      if (this.disabled || this.uploading) {
        return;
      }
      this.isShowCrop = true;
    },
    removeBeforeUpload(file, fileList) { },
    handleSetFileSet(fileName, fileType, fileSize) {
      const uid = this.cropData.uid || new Date().getTime();
      this.cropData = {
        name: fileName,
        percentage: 0,
        size: fileSize,
        type: fileType,
        status: "ready",
        uid: uid
      };
    },
    handleCropSuccess(b64Data) {
      this.cropData.url = b64Data;
    },
    handleCropUploadError(status) {
      if (this.showUploadLenght >= this.limit)
        return this.$message.error(`最多上传${this.limit}张图片`);
      this.$message.error("上传失败, 请重试");
      this.$emit("error", status);
    },
    //压缩图片方法
    compressImg(file) {
      //debugger
      return new Promise((resolve, reject) => {

        imageConversion.compress(file, 0.8).then(res => {
          res = new File([res], file.name, {
            type: res.type,
            lastModified: Date.now()
          });
          this.compressLoad = false
          console.log("压缩后", res.size / 1024 / 1024);
          if (res.size / 1024 / 1024 < this.fileSize) {
            resolve(res)
          } else {
             reject(`上传图片大小不能超过 ${this.fileSize} MB!`); 
          }
        }).catch(err => {
          reject('图片信息异常！');
        });
      });
    },
    handleCropUploadSuccess(response) {
      this.cropData.status = "success";
      this.cropData.percentage = 100;
      this.cropData.response = response;
      const file = Object.assign({}, this.cropData);
      let index = this.fileList.findIndex(item => item.uid === file.uid);
      if (index > -1) {
        this.fileList.splice(index, 1, file);
      } else {
        this.fileList.push(file);
      }
      this.handleUploadSuccess(response, file, this.fileList);
    },
    // 上传前校检格式和大小
    async handleBeforeUpload(file) { 
      let _this = this; 
      return new Promise(async (resolve, reject) => {
        if (this.disabled || this.uploading) {
          return reject(false);
        }
        let a = true;
        if (typeof this.beforeUpLFn == "function") {
          a = await this.beforeUpLFn();
        }
        if (!a) return reject(false);
        let isImg = false;
        if (this.fileType.length) {
          let fileExtension = "";
          if (file.name.lastIndexOf(".") > -1) {
            fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
          }
          isImg = this.fileType.some(type => {
            if (file.type.indexOf(type) > -1) return true;
            if (fileExtension && fileExtension.indexOf(type) > -1) return true;
            return false;
          });
        } else {
          isImg = file.type.indexOf("image") > -1;
        }

        if (!isImg) {
          this.$message.error(
            `文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`
          );
          return reject(false);
        }
        if (this.data.appId !== undefined && !this.data.appId) {
          this.$message.error("请选择微信公众号");
          return reject(false);
        }
        if (this.widthHeightVali) {
          let res = await this.bigImgFun(
            file,
            this.widthValue,
            this.heightValue
          );
          if (!res) {
            this.uploading = false;
            return reject(false);
          }
        }
        if (this.fileSize) {
          const isLt = file.size / 1024 / 1024 < this.fileSize; 
          if (!isLt) {
            //进行压缩
            if (this.isCompress) {
              console.log('压缩前文件大小：', file.size / 1024 / 1024) 
              this.compressLoad = true
              try{
                let res = await this.compressImg(file)
                if (!res) {
                  this.uploading = false;
                  return reject(false);
                }else{ 
                  console.log("压缩后大小", res.size)
                  this.uploading = true
                  return resolve(res)
                }
              }catch(e){ 
                this.compressLoad = false
                this.$message.error(e);
                return reject(false); 
              }
            } else {
              this.$message.error(`上传图片大小不能超过 ${this.fileSize} MB!`);
              return reject(false);
            }
          }
        }


        // if (this.isCompress) {
        //   console.log("压缩前", file.size);
        //   try {
        //     const image = new Image();
        //     image.src = URL.createObjectURL(file);
        //     image.onload = function() {
        //       const that = this;
        //       // 默认按比例压缩
        //       let w = that.width;
        //       let h = that.height;
        //       const scale = w / h;
        //       w = file.width || w;
        //       h = file.height || w / scale;
        //       let quality = 0.5; // 默认图片质量为0.7
        //       const canvas = document.createElement("canvas");
        //       const ctx = canvas.getContext("2d");
        //       ctx.clearRect(0, 0, w, h); // 清除画布内容
        //       canvas.setAttribute("width", w); // 设置画布宽度
        //       canvas.setAttribute("height", h); // 设置画布高度
        //       ctx.fillStyle = "rgba(0, 0, 0, 0.1)"; // 设置透明背景
        //       ctx.fillRect(0, 0, w, h); // 填充透明背景
        //       ctx.drawImage(that, 0, 0, w, h);
        //       // 图像质量
        //       if (file.quality && file.quality <= 1 && file.quality > 0) {
        //         quality = file.quality;
        //       }
        //       // quality值越小，所绘制出的图像越模糊
        //       const data = canvas.toDataURL("image/jpeg", quality);
        //       const newFile = _this.convertBase64UrlToBlob(data);
        //       let files = new window.File(
        //         [newFile],
        //         file.name.split(".")[0] + ".png",
        //         { type: "image/png" }
        //       );
        //       console.log("压缩结果", files.size);
        //       return resolve(files);
        //     };
        //   } catch (e) {
        //     console.log(e, "压缩失败");
        //   }
        // } 
        this.uploading = true;  
        return resolve(true); 
      });
    },
    convertBase64UrlToBlob(urlData) {
      const bytes = window.atob(urlData.split(",")[1]); // 去掉url的头，并转换为byte
      // 处理异常,将ascii码小于0的转换为大于0
      const ab = new ArrayBuffer(bytes.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], { type: "image/jpg" });
    },
    bigImgFun(file, width, height) {
      //验证图片宽高
      return new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let image = new Image();
        let that = this;
        image.onload = function () {
          let isSize = true;
          // sizeOfThe lessEqual greaterEqual
          if (that.sizeOfThe == "lessEqual") {
            if (width && !height) {
              isSize = image.width <= width;
            }
            if (width && height) {
              isSize = image.width <= width && image.height <= height;
            }
            if (!width && height) {
              image.height <= height;
            }
          } else if (that.sizeOfThe == "greaterEqual") {
            if (width && !height) {
              isSize = image.width >= width;
            }
            if (width && height) {
              isSize = image.width >= width && image.height >= height;
            }
            if (!width && height) {
              image.height >= height;
            }
          } else if (that.sizeOfThe == "widthEqualHeight") {
            isSize = image.width == image.height;
          } else {
            if (width && !height) {
              isSize = image.width == width;
            }
            if (width && height) {
              isSize = image.width == width && image.height == height;
            }
            if (!width && height) {
              image.height == height;
            }
          }

          // let isSize = image.width == width && image.height == height;
          // console.log(isSize, "isSize");
          resolve(isSize);
          if (!isSize) {
            if (that.sizeOfThe == "lessEqual") {
              if (width && !height) {
                that.$message.error(`上传图片宽度不大于${width}`);
              }
              if (width && height) {
                that.$message.error(`上传图片尺寸不大于为${width}*${height}`);
              }
              if (!width && height) {
                that.$message.error(`上传图片高度不大于为${height}`);
              }
            } else if (that.sizeOfThe == "greaterEqual") {
              if (width && !height) {
                that.$message.error(`上传图片宽度不小于为${width}`);
              }
              if (width && height) {
                that.$message.error(`上传图片尺寸不小于为${width}*${height}`);
              }
              if (!width && height) {
                that.$message.error(`上传图片高度不小于为${height}`);
              }
            } else if (that.sizeOfThe == "widthEqualHeight") {
              that.$message.error(`上传图片宽高比须是1：1`);
            } else {
              if (width && !height) {
                that.$message.error(`上传图片宽度为${width}`);
              }
              if (width && height) {
                that.$message.error(`上传图片尺寸为${width}*${height}`);
              }
              if (!width && height) {
                that.$message.error(`上传图片高度为${height}`);
              }
            }
          }
          return isSize;
        };
        image.src = _URL.createObjectURL(file);
      });
    },
    handleChange(file, fileList) {
      this.uploading = false;
      // if (file.status === 'success') {
      // 	if (!file.response.status) {
      // 		this.$message.error(file.response.message)
      // 	}
      // }

      // if(fileList.length>this.limit){
      // 	return
      // }

      this.fileList = fileList;
    },
    // 文件个数超出
    handleExceed(files, fileList) {
      this.$message.error(`最多上传${this.limit}张图片`);
    },
    // 上传失败
    handleUploadError(err) {
      this.uploading = false;
      this.$message.error("上传失败, 请重试");
      this.$emit("error", err);
    },
    // 上传成功回调
    handleUploadSuccess(response, file, e) {
      if (this.showUploadLenght >= this.limit)
        return this.$message.error(`最多上传${this.limit}张图片`);
      // if(response.)
      //上传成功回调
      let url = response;
      this.uploading = false;

      if (this.isShowSuccessTip && response.success) {
        this.$message.success("上传成功");
      }
      if (!response.success) {
        this.$message.error(response.message);
      }
      if (this.responseFn) {
        url = this.responseFn(
          response,
          file,
          this.successFiles,
          this.itemIndex
        );
      }
      if (this.multiple || this.checkMore) {
        //多图上传
        if (Array.isArray(this.value)) {
          this.$emit("input", [...this.value]);
        } else {
          this.$emit("input", [url]);
        }
      } else {
        this.$emit("input", url);
      }
    },
    doRemove(index) {
      if (!this.doRemoveNo) {
        return false;
      }
      if (this.multiple || this.checkMore) {
        const data = [...this.computedValues];
        data.splice(index, 1);
        this.$emit("input", data || []);
      } else {
        this.$emit("input", null);
      }
    },
    handleRemove(index) {
      if (!this.beforeRemove) {
        // this.$emit('isModify', true)
        this.doRemove(index);
      } else if (typeof this.beforeRemove === "function") {
        const file =
          this.multiple || this.checkMore
            ? this.computedValues[index]
            : this.computedValues;
        const before = this.beforeRemove(file, this.computedValues, index);
        if (before && before.then) {
          before.then(
            () => {
              this.doRemove(index);
            },
            () => { }
          );
        } else if (before !== false) {
          this.doRemove(index);
        }
      }
    }
  },
  mounted() {
    // // 插入到body中, 避免弹出层被遮盖
    // if (this.crop && this.$refs.cropper) {
    //   document.body.appendChild(this.$refs.cropper.$el);
    // }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-loading-text{
  position: absolute;
  top: 15px;
  left: 22px;
  font-size: 12px;
}
.wHL {
  width: 100px !important;
  height: 100px !important;
  line-height: 100px !important;
}

.message {
  color: #999999;
  margin-left: 20px;
  display: flex;
  flex-direction: column-reverse;
}

.ele-upload-image {
  line-height: 1;
  display: flex;
}

.ele-upload-image {
  margin-right: 10px !important;
}

.ele-upload-image .el-loading-spinner {
  line-height: 1;
}

.ele-upload-image .el-icon-plus {
  vertical-align: middle;
}

.ele-upload-image .el-upload--picture-card {
  width: auto;
  height: auto;
  background: none;
  line-height: inherit;
}

.upload-image {
  & /deep/ .el-upload {
    margin-right: 10px !important;
    width: 100% !important;
    height: 100% !important;
    line-height: 100% !important;
  }

  & /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100% !important;
    height: 100% !important;
    line-height: 100% !important;
  }

  & /deep/ .el-upload-list--picture-card .div {
    background: red;
    width: 100% !important;
    height: 100% !important;
    line-height: 100% !important;
  }

  & /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 100% !important;
    height: 100% !important;
    line-height: 100% !important;
  }

  & /deep/ .avatar {
    width: 100% !important;
    height: 100% !important;
    line-height: 100% !important;
  }

  & .el-upload .el-upload--picture-card div {
    width: 100% !important;
    height: 100% !important;
    line-height: 100% !important;
  }
}

/* 裁剪
.vue-image-crop-upload.ele-upload-image--cropper {
  z-index: 99;
}
.ele-upload-image--cropper .vicp-drop-area {
  background-color: #fbfdff !important;
}
.ele-upload-image--cropper .vicp-icon1-arrow {
  border-bottom-color: #909399 !important;
}
.ele-upload-image--cropper .vicp-icon1-body {
  background-color: #909399 !important;
}
.ele-upload-image--cropper .vicp-icon1-bottom {
  border-color: #909399 !important;
} */
</style>
